/**
 * WebSmReconsider — the "staying is the task" countdown (ported from Glow's
 * WebSmReconsider_type.jsx). Options: Title / Message / Seconds / Caption
 *   / ReadyLabel / BgColor / AccentColor. Emits CLICK1 once the timer hits 0.
 */
import { useEffect, useState } from "react";
import {
  CARD_CLASS,
  PRIMARY_BTN_CLASS,
  SECTION_CLASS,
  SUBMESSAGE_CLASS,
  stepVars,
} from "./step-shell";
import type { StepTypeProps } from "./types";

export default function WebSmReconsiderType({
  getOpt,
  dispatch,
}: StepTypeProps) {
  const bg = getOpt("BgColor") || "#0a0809";
  const accent = getOpt("AccentColor") || "#d6a94e";
  const total = Math.max(1, parseInt(getOpt("Seconds"), 10) || 60);

  const title = getOpt("Title") || "The door is closed.";
  const message =
    getOpt("Message") ||
    "If you're still here when this reaches zero, we'll know you're serious.";
  const caption = getOpt("Caption") || "staying is the task";
  const readyLabel = getOpt("ReadyLabel") || "Come in";

  const [count, setCount] = useState(total);
  // `total` is fixed for this step's lifetime (it comes from the step's
  // Seconds option), so count is seeded once via useState and ticks down here.
  useEffect(() => {
    const iv = setInterval(() => {
      setCount((c) => {
        if (c <= 1) {
          clearInterval(iv);
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(iv);
  }, [total]);

  const done = count <= 0;

  return (
    <section
      style={stepVars({ accent, bg })}
      className={`${SECTION_CLASS} px-4 py-12`}
    >
      <div className={CARD_CLASS}>
        {/* red, not the usual bone — this screen is still a refusal */}
        <div className="mb-4 text-[22px] leading-[1.32] font-bold text-[#d8635c] [text-shadow:0_0_18px_rgba(216,99,92,.3)]">
          {title}
        </div>
        {message ? <div className={SUBMESSAGE_CLASS}>{message}</div> : null}

        <div className="mt-6 mb-1 text-center">
          <div className="font-mono text-[54px] font-semibold text-[#f0c674] tabular-nums [text-shadow:0_0_24px_rgba(240,198,116,.4)]">
            {count}
          </div>
          <div className="mt-1.5 font-mono text-[11px] tracking-[.3px] text-[#9b8f79]">
            {caption}
          </div>
        </div>

        {done && readyLabel ? (
          <button
            type="button"
            onClick={() => dispatch("CLICK1")}
            className={`mt-5 ${PRIMARY_BTN_CLASS}`}
          >
            {readyLabel}
          </button>
        ) : null}
      </div>
    </section>
  );
}
